export const normalizeText = (text: string | undefined | null): string => {
    if (!text) return '';
    return text
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
};

// Grupos de sinónimos y plurales para una búsqueda más robusta.
const synonymGroups: string[][] = [
    // Tarjetas
    ['tarjeta', 'tarjetas', 'card', 'cards', 'business card', 'visita', 'visitas', 'presentacion', 'presentaciones'],
    // Volantes
    ['volante', 'volantes', 'flyer', 'flyers', 'folleto', 'folletos', 'propaganda'],
    // Lonas
    ['lona', 'lonas', 'banner', 'banners', 'pendon', 'pendones', 'pancarta', 'pancartas'],
    // Stickers
    ['sticker', 'stickers', 'pegatina', 'pegatinas', 'calcomania', 'calcomanias', 'etiqueta', 'etiquetas', 'label', 'labels', 'adhesivo', 'adhesivos'],
];

// 1. Create a flat, unique, normalized list of all known synonym terms.
const allSynonymTerms = [...new Set(synonymGroups.flat().map(normalizeText))];

// 2. Create a map where each known term maps to its full synonym group.
const synonymMap: { [key: string]: string[] } = {};
synonymGroups.forEach(group => {
    const normalizedGroup = group.map(normalizeText);
    normalizedGroup.forEach(term => {
        synonymMap[term] = normalizedGroup;
    });
});

/**
 * Expands a search query to include synonyms and handle prefixes.
 * If the user types "etiq", it finds "etiqueta" and expands the search to include
 * "stickers", "pegatinas", etc., making the search much more powerful.
 */
export const expandQuery = (query: string): string[] => {
    const normalizedQuery = normalizeText(query);
    const terms = normalizedQuery.split(/\s+/).filter(Boolean);
    const expandedTerms = new Set<string>();

    terms.forEach(term => {
        // Add the original term itself for basic prefix matching
        expandedTerms.add(term);

        // Find all known synonym terms that start with the user's term
        allSynonymTerms.forEach(synonym => {
            if (synonym.startsWith(term)) {
                // If a prefix match is found (e.g., 'etiqueta' starts with 'etiq'),
                // add the entire synonym group for that term to the search.
                if (synonymMap[synonym]) {
                    synonymMap[synonym].forEach(groupTerm => expandedTerms.add(groupTerm));
                }
            }
        });
    });

    // If after all that, we only have the original search term, it might be
    // something not in our synonym list. Do a simple pluralization as a fallback.
    if (expandedTerms.size === terms.length) {
        terms.forEach(term => {
            if (term.length > 2) {
                 if (term.endsWith('es')) {
                    expandedTerms.add(term.slice(0, -2));
                } else if (term.endsWith('s')) {
                    expandedTerms.add(term.slice(0, -1));
                } else {
                    expandedTerms.add(term + 's');
                }
            }
        });
    }

    return Array.from(expandedTerms);
};
